'use client'

import * as React from 'react'
import { useSpring, useTransform, motion } from 'framer-motion'

//Do not ask :))
//Math.round(-0.49) => -0
function fixNegativeZero(n: number) {
  return n === 0 ? 0 : n
}

export function AnimatedNumber({ value, className }: { value: number; className?: string }) {
  const spring = useSpring(value, { mass: 0.8, stiffness: 75, damping: 15 })
  const display = useTransform(spring, current => {
    const mathValue = fixNegativeZero(Math.round(current))

    if (mathValue < 0) {
      return '0'
    }

    return mathValue.toLocaleString()
  })

  React.useEffect(() => {
    spring.set(value)
  }, [spring, value])

  return (
    <motion.span className={className} suppressHydrationWarning>
      {display}
    </motion.span>
  )
}
